<template>
  <div
    id="borrower-footer"
    class="pb-6 mb-6"
  >
    <v-layout
      v-if="store.servicer"
      row
    >
      <v-flex
        sm8
        offset-sm2
        md6
        offset-md3
        class="mb-5 grey--text text--darken-1 body-2 text-sm-center text-xs-center"
      >
        <span
          v-if="store.servicer.effective_company_name"
        >
          {{ filterCompanyName(store.servicer.effective_company_name) }}
        </span>
        <span
          v-if="store.servicer.effective_address"
        >
          {{ store.servicer.effective_address + ', ' }}
        </span>
        <span v-if="isValidNMLS(store.servicer.effective_company_nmls)">{{ filterLicense(store.servicer.effective_company_nmls) }} / </span>
        <span>{{ store.servicer.name }} {{ store.servicer.last_name }}</span>
        <br>
        <span v-if="isValidNMLS(store.servicer.license)">{{ filterLicense(store.servicer.license) }}</span>
        <template v-for="license in store.servicer.state_lics">
          &nbsp;&nbsp;
          {{ license.state }}: {{ license.value }}
        </template>
        <br>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="store.servicer && (store.servicer.effective_website_disclaimer || ShouldShowPrivacyPolicyLink || ShouldShowTermsOfUseLink)"
      justify-center
      row
    >
      <v-flex
        class="ma-2"
        sm6
      >
        <p class="grey--text text--darken-1">
          <span v-if="store.servicer.effective_website_disclaimer">
            <span v-html="store.servicer.effective_website_disclaimer" />
          </span>
          <span v-if="ShouldShowPrivacyPolicyLink">
            Click <a :href="store.servicer.effective_privacy_policy_link">here</a> to see our privacy policy.
          </span>
          <span v-if="ShouldShowTermsOfUseLink">
            Click <a :href="store.servicer.company.terms_of_use_link">here</a> to see our terms of use.
          </span>
        </p>
      </v-flex>
    </v-layout>

    <v-layout
      v-if="store.servicer"
      row
      justify-center
      :column="this.$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        class="mb-5"
        xs1
      >
        <template v-for="(logo, index) in store.servicer.effectiveEhLogos">
          <img
            :key="`ehLogo-${index}`"
            :src="`${logo.iconUrl}`"
            :alt="`${logo.iconName} logo`"
            width="82"
            class="mx-3 my-1"
          >
        </template>
      </v-flex>
      <v-flex
        v-if="store.servicer.consumer_access_link"
        class="mb-5"
        xs1
      >
        <a
          :href="store.servicer.consumer_access_link"
          target="_blank"
        >
          <img
            :src="NMLSLogoDark"
            alt="consumer access link"
            width="82"
            class="mx-3 my-1"
          >
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AutoLogoutMixin from '~/util/AutoLogoutMixin'
import NMLSLogoDark from '~/assets/images/NMLS-logo-dark.png'
export default {
  name: 'BorowerFooter',
  mixins: [AutoLogoutMixin],
  data () {
    return {
      store: this.$store,
      NMLSLogoDark: NMLSLogoDark
    }
  },
  computed: {
    shouldShowCompanyLegalLinks () {
      return this.store.servicer.company && this.store.servicer.company.show_company_legal_links
    },
    ShouldShowPrivacyPolicyLink () {
      return this.shouldShowCompanyLegalLinks && this.store.servicer.effective_privacy_policy_link
    },
    ShouldShowTermsOfUseLink () {
      return this.shouldShowCompanyLegalLinks && this.store.servicer.company.terms_of_use_link
    }
  },
  mounted () {
    if (this.sn_AutoLogoutMixin_isIE()) {
      const index = this.store.servicer.state_lics.findIndex(stateLic => stateLic.value.length > 89)
      if (index !== -1) {
        const tempLic = this.store.servicer.state_lics[index].value
        setTimeout(() => {
          this.store.servicer.state_lics[index].value = this.store.servicer.state_lics[index].value.slice(0, 50)
          setTimeout(() => {
            this.store.servicer.state_lics[index].value = tempLic
          }, 0)
        }, 0)
      }
    }
  },
  methods: {
    filterCompanyName (name) {
      if (name) {
        return name
      } else return ''
    },
    filterLicense (nmls) {
      if (nmls) {
        if (nmls.includes('NMLS') && nmls.includes('#')) return nmls
        else if (nmls.includes('#')) return `NMLS ${nmls}`
        else return `NMLS #${nmls}`
      }
    },
    isValidNMLS (nmls) {
      if (nmls === null || nmls === '') {
        return false
      // For certain servicers, the NMLS was prepended even if there wasn't a number
      } else if (nmls === 'NMLS #' || nmls === 'NMLS# ' || nmls === 'NMLS # ' || nmls === 'NONE') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
